import { connectedStore } from '../../store';
import getBlockVariations from '../selectors/block-variations';
import getBlock from '../selectors/block';

const getBlockCategory = (blockId, blockVariationId) => {
  const store = connectedStore.get();
  const state = store.getState();
  const variations = getBlockVariations(state, blockId);

  if (variations?.length) {
    const targetVariation = variations.find((item) => item.id === blockVariationId);
    const targetCategory = targetVariation?.category;
    if (targetCategory) {
      return targetCategory;
    }
  }

  const block = getBlock(state, blockId);
  return block?.category || null;
};

export default getBlockCategory;
